import { render } from "./InfoRowSymptom.vue?vue&type=template&id=4bc09304"
import script from "./InfoRowSymptom.vue?vue&type=script&lang=js"
export * from "./InfoRowSymptom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__